import React, { useState } from 'react';
import './AddCardTypeModal.css';
import AppIcon from './icons/AppIcon';

export default function AddCardTypeModal({ isOpen, onClose, onSelectType, projectType }) {
  if (!isOpen) return null;

  const cardTypes = [
    {
      type: 'normal',
      icon: 'task',
      title: 'Card Normal',
      description: 'Card tradicional do Kanban com tarefas e checklists',
      color: '#44e1ff'
    }
  ];

  // Se for projeto CRM ou CRM Multi, adicionar opção de card de contato
  if (projectType === 'crm' || projectType === 'crm_multi') {
    cardTypes.push({
      type: 'contact',
      icon: 'person',
      title: 'Card de Contato',
      description: 'Vincular um contato existente como lead',
      color: '#b43bea'
    });
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="add-card-type-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Escolha o tipo de card</h2>
          <button className="btn-close" onClick={onClose}>
            <AppIcon name="close" />
          </button>
        </div>

        <div className="card-types-grid">
          {cardTypes.map((cardType) => (
            <button
              key={cardType.type}
              className="card-type-option"
              onClick={() => onSelectType(cardType.type)}
            >
              <div className="card-type-icon" style={{ backgroundColor: cardType.color }}>
                <AppIcon name={cardType.icon} />
              </div>
              <div className="card-type-info">
                <h3>{cardType.title}</h3>
                <p>{cardType.description}</p>
              </div>
              <AppIcon name="arrow_forward" className="arrow" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
